<div class="vtr-ui-rounded-rectangle-radio {{group}}"
	[ngClass]="{'border-blue':checked && !disabled,
	'border-grey':!checked&&!disabled,
	'large-width': isLarge,
	'border-checked-disabled': checked && disabled,
	'border-disabled': disabled && !checked}"
	id="{{'div'+radioId}}"
	role="radio"
	#radioButton
	[tabIndex]="disabled ?-1:checked? 0 :-1"
	[attr.aria-disabled]="disabled"
	[attr.aria-checked]="checked"
	[attr.aria-labelledby]="radioId"
	(keydown)="navigateByKeys($event,radio)">
	<input id="{{radioId}}"
		style="display: none;"
		attr.aria-labelledby="{{radioId}}-title"
		name="{{group}}"
		type="radio"
		[value]="value"
		[checked]="checked"
		[disabled]="disabled"
		#radio
		(click)="onChange(value)"
		aria-hidden="true"
		tabindex="-1" />
	<label for="{{radioId}}"
		id="{{radioId}}-label"
		attr.aria-labelledby="{{radioId}}-title">
		<fa-layers [fixedWidth]="true"
			class="icon-circle">
			<fa-icon [icon]="['fal', 'circle']"></fa-icon>
			<fa-icon [icon]="['fas', 'circle']"
				transform="shrink-6"
				*ngIf="checked"
				class="checked-circle"></fa-icon>
		</fa-layers>
		<span class="label"
			id="{{radioId}}-title">{{label}}</span>
	</label>
</div>
